// Comprehensive list of Indian colleges and universities
const INDIAN_COLLEGES = [
  // ── IITs ──
  "IIT Bombay", "IIT Delhi", "IIT Madras", "IIT Kharagpur", "IIT Kanpur",
  "IIT Roorkee", "IIT Guwahati", "IIT Hyderabad", "IIT Indore", "IIT Jodhpur",
  "IIT Mandi", "IIT Patna", "IIT Ropar", "IIT Bhubaneswar", "IIT Gandhinagar",
  "IIT Tirupati", "IIT Palakkad", "IIT Jammu", "IIT Dharwad", "IIT Bhilai",
  "IIT Goa", "IIT (BHU) Varanasi", "IIT (ISM) Dhanbad",

  // ── NITs ──
  "NIT Trichy", "NIT Warangal", "NIT Surathkal", "NIT Calicut", "NIT Rourkela",
  "NIT Allahabad (MNNIT)", "VNIT Nagpur", "NIT Kurukshetra", "NIT Jaipur (MNIT)",
  "NIT Durgapur", "NIT Bhopal (MANIT)", "NIT Patna", "NIT Silchar",
  "NIT Srinagar", "NIT Hamirpur", "NIT Jalandhar", "NIT Agartala",
  "NIT Meghalaya", "NIT Manipur", "NIT Mizoram", "NIT Nagaland",
  "NIT Arunachal Pradesh", "NIT Puducherry", "NIT Sikkim", "NIT Uttarakhand",
  "NIT Delhi", "NIT Andhra Pradesh", "NIT Goa", "NIT Raipur",
  "NIT Surat (SVNIT)", "NIT Jamshedpur",

  // ── IIMs ──
  "IIM Ahmedabad", "IIM Bangalore", "IIM Calcutta", "IIM Lucknow",
  "IIM Kozhikode", "IIM Indore", "IIM Shillong", "IIM Rohtak", "IIM Raipur",
  "IIM Ranchi", "IIM Udaipur", "IIM Kashipur", "IIM Trichy", "IIM Bodh Gaya",
  "IIM Jammu", "IIM Amritsar", "IIM Nagpur", "IIM Visakhapatnam",
  "IIM Sirmaur", "IIM Sambalpur",

  // ── BITS ──
  "BITS Pilani", "BITS Goa", "BITS Hyderabad", "BITS Dubai",

  // ── AIIMS ──
  "AIIMS New Delhi", "AIIMS Bhopal", "AIIMS Bhubaneswar", "AIIMS Jodhpur",
  "AIIMS Patna", "AIIMS Raipur", "AIIMS Rishikesh", "AIIMS Nagpur",
  "AIIMS Mangalagiri", "AIIMS Gorakhpur", "AIIMS Bathinda", "AIIMS Bibinagar",
  "AIIMS Deoghar", "AIIMS Guwahati", "AIIMS Jammu", "AIIMS Kalyani",
  "AIIMS Rajkot", "AIIMS Vijaypur",

  // ── Central Universities ──
  "University of Delhi", "Jawaharlal Nehru University (JNU)",
  "Banaras Hindu University (BHU)", "Aligarh Muslim University (AMU)",
  "Hyderabad University", "Jamia Millia Islamia", "Jadavpur University",
  "University of Hyderabad", "Pondicherry University", "Tezpur University",
  "Mizoram University", "Manipur University", "Nagaland University",
  "Sikkim University", "Tripura University", "Assam University",
  "Central University of Gujarat", "Central University of Rajasthan",
  "Central University of Punjab", "Central University of Haryana",
  "Central University of Jharkhand", "Central University of Karnataka",
  "Central University of Kerala", "Central University of Kashmir",
  "Central University of Tamil Nadu", "Central University of Himachal Pradesh",
  "Central University of Odisha", "Central University of South Bihar",
  "Hemvati Nandan Bahuguna Garhwal University",
  "Guru Ghasidas Vishwavidyalaya", "Mahatma Gandhi Central University",
  "Dr. Harisingh Gour Vishwavidyalaya", "Indira Gandhi National Open University (IGNOU)",

  // ── IIITs ──
  "IIIT Hyderabad", "IIIT Allahabad", "IIIT Bangalore", "IIIT Delhi",
  "IIIT Gwalior", "IIIT Jabalpur", "IIIT Kancheepuram", "IIIT Kota",
  "IIIT Lucknow", "IIIT Manipur", "IIIT Nagpur", "IIIT Pune",
  "IIIT Ranchi", "IIIT Srirangam", "IIIT Tiruchirappalli", "IIIT Una",
  "IIIT Vadodara", "IIIT Dharwad", "IIIT Kalyani", "IIIT Sri City",
  "IIIT Bhagalpur", "IIIT Bhopal", "IIIT Agartala", "IIIT Raichur",
  "IIIT Surat", "IIIT Sonepat",

  // ── Mumbai Region ──
  "Veermata Jijabai Technological Institute (VJTI)",
  "Institute of Chemical Technology (ICT Mumbai)",
  "Sardar Patel Institute of Technology (SPIT)",
  "K.J. Somaiya College of Engineering",
  "Thadomal Shahani Engineering College",
  "NMIMS University",
  "D.J. Sanghvi College of Engineering",
  "Thakur College of Engineering",
  "Fr. Conceicao Rodrigues College of Engineering",
  "Pillai College of Engineering",
  "Terna Engineering College",
  "St. Francis Institute of Technology",
  "Atharva College of Engineering",
  "Vidyalankar Institute of Technology",
  "Universal College of Engineering",
  "SIES Graduate School of Technology",
  "Don Bosco Institute of Technology",
  "Xavier Institute of Engineering",
  "Shah and Anchor Kutchhi Engineering College",
  "Rajiv Gandhi Institute of Technology (Mumbai)",
  "Vivekanand Education Society's Institute of Technology",
  "Rizvi College of Engineering",
  "Mumbai University",
  "St. Xavier's College Mumbai",
  "HR College of Commerce and Economics",
  "Jai Hind College",
  "Mithibai College",
  "Ruia College",
  "Wilson College",

  // ── Pune Region ──
  "Pune Institute of Computer Technology (PICT)",
  "College of Engineering Pune (COEP)",
  "Symbiosis Institute of Technology (SIT)",
  "MIT College of Engineering Pune",
  "VIT Pune",
  "Vishwakarma Institute of Technology (VIT Pune)",
  "Cummins College of Engineering for Women",
  "Sinhgad College of Engineering",
  "Pimpri Chinchwad College of Engineering (PCCOE)",
  "Indira College of Engineering and Management",
  "Army Institute of Technology Pune",
  "DY Patil College of Engineering Pune",
  "Bharati Vidyapeeth College of Engineering Pune",
  "Zeal College of Engineering and Research",
  "Marathwada Mitra Mandal's College of Engineering",
  "Fergusson College Pune",
  "Symbiosis College of Arts and Commerce",
  "Symbiosis International University",
  "Savitribai Phule Pune University",
  "Deccan College of Engineering",
  "Modern College of Engineering",
  "Genba Sopanrao Moze College of Engineering",
  "Sandip Foundation's Institute of Technology",
  "Indira Gandhi College of Engineering",

  // ── Nagpur Region ──
  "Visvesvaraya National Institute of Technology (VNIT Nagpur)",
  "Shri Ramdeobaba College of Engineering",
  "Yeshwantrao Chavan College of Engineering (YCCE)",
  "KDK College of Engineering",
  "Priyadarshini Institute of Engineering",
  "Laxminarayan Institute of Technology (LIT Nagpur)",
  "Nagpur University",

  // ── Bangalore / Karnataka ──
  "Indian Institute of Science (IISc Bangalore)",
  "RV College of Engineering",
  "BMS College of Engineering",
  "PES University",
  "MS Ramaiah Institute of Technology",
  "Manipal Institute of Technology",
  "Manipal University",
  "NMAM Institute of Technology",
  "Nitte Meenakshi Institute of Technology",
  "Dayananda Sagar College of Engineering",
  "Bangalore Institute of Technology",
  "JSS Academy of Technical Education",
  "Visvesvaraya Technological University (VTU)",
  "Christ University Bangalore",
  "Bangalore University",
  "Jain University",
  "Reva University",
  "CMR Institute of Technology",
  "East Point College of Engineering",
  "New Horizon College of Engineering",
  "Sir M Visvesvaraya Institute of Technology",
  "Global Academy of Technology",
  "KS School of Engineering",

  // ── Chennai / Tamil Nadu ──
  "Anna University",
  "College of Engineering Guindy (CEG)",
  "SSN College of Engineering",
  "PSG College of Technology",
  "Coimbatore Institute of Technology",
  "Sri Sivasubramaniya Nadar College of Engineering",
  "Vellore Institute of Technology (VIT Vellore)",
  "SRM Institute of Science and Technology",
  "Amrita Vishwa Vidyapeetham",
  "Saveetha Engineering College",
  "Rajalakshmi Engineering College",
  "Sri Krishna College of Engineering",
  "Kumaraguru College of Technology",
  "Thiagarajar College of Engineering",
  "National Engineering College",
  "Kongu Engineering College",
  "Loyola College Chennai",
  "Presidency College Chennai",
  "Madras Christian College",
  "Sri Venkateswara College of Engineering",

  // ── Hyderabad / Telangana ──
  "Osmania University",
  "University College of Engineering (Osmania)",
  "CVR College of Engineering",
  "Chaitanya Bharathi Institute of Technology",
  "Gokaraju Rangaraju Institute of Engineering",
  "Vasavi College of Engineering",
  "Malla Reddy Engineering College",
  "Jawaharlal Nehru Technological University Hyderabad (JNTUH)",
  "Jawaharlal Nehru Technological University Kakinada (JNTUK)",
  "ICFAI Foundation for Higher Education",
  "Mahindra University Hyderabad",
  "Woxsen University",

  // ── Delhi / NCR ──
  "Delhi Technological University (DTU)",
  "Netaji Subhas University of Technology (NSUT)",
  "Indraprastha Institute of Information Technology (IIIT Delhi)",
  "Guru Gobind Singh Indraprastha University",
  "Jamia Hamdard",
  "Amity University Noida",
  "Shiv Nadar University",
  "Bennett University",
  "Galgotias University",
  "GL Bajaj Institute of Technology",
  "Jaypee Institute of Information Technology",
  "Jaypee University of Engineering",
  "Maharaja Agrasen Institute of Technology",
  "Vivekananda Institute of Professional Studies",
  "ABES Engineering College",
  "Kiet Group of Institutions",
  "HMR Institute of Technology",
  "Bharati Vidyapeeth Delhi",
  "IP College for Women",
  "Lady Shri Ram College",
  "Miranda House",
  "Hindu College Delhi",
  "Kirori Mal College",
  "Sri Venkateswara College Delhi",
  "Hansraj College",
  "Dyal Singh College",
  "Atma Ram Sanatan Dharma College",
  "Ramjas College",

  // ── Rajasthan ──
  "Malaviya National Institute of Technology Jaipur",
  "Birla Institute of Technology and Science Pilani",
  "University of Rajasthan",
  "Rajasthan Technical University",
  "LNM Institute of Information Technology",
  "Poornima University",
  "Manipal University Jaipur",
  "Amity University Jaipur",
  "JECRC University",
  "IIS University Jaipur",
  "Banasthali Vidyapith",
  "Vivekananda Global University",

  // ── Gujarat ──
  "Dhirubhai Ambani Institute of Information and Communication Technology",
  "Sardar Vallabhbhai National Institute of Technology (SVNIT Surat)",
  "Gujarat Technological University",
  "L.D. College of Engineering",
  "Nirma University",
  "Charotar University of Science and Technology (CHARUSAT)",
  "Silver Oak University",
  "Marwadi University",
  "Parul University",
  "Ganpat University",
  "Gujarat University",
  "MS University Baroda",
  "Sardar Patel University",
  "BVM Engineering College",
  "Indus University",
  "IITE Ahmedabad",

  // ── Madhya Pradesh ──
  "Maulana Azad National Institute of Technology (MANIT Bhopal)",
  "IIT Indore",
  "IIIT Gwalior",
  "IIIT Bhopal",
  "LNCT Bhopal",
  "Rajiv Gandhi Proudyogiki Vishwavidyalaya",
  "Sage University",
  "ITM University Gwalior",
  "Jabalpur Engineering College",
  "Shri GS Institute of Technology",
  "NRI Institute of Information Science and Technology",
  "Devi Ahilya Vishwavidyalaya",
  "Vikram University",

  // ── Uttar Pradesh ──
  "IIT Kanpur", "IIT (BHU) Varanasi",
  "MNNIT Allahabad",
  "Harcourt Butler Technical University",
  "AKTU (Dr. APJ Abdul Kalam Technical University)",
  "Aligarh Muslim University",
  "Lucknow University",
  "Allahabad University",
  "Amity University Lucknow",
  "IIIT Lucknow",
  "IIIT Allahabad",
  "GL Bajaj Group of Institutions",
  "AIET Lucknow",
  "Integral University",
  "Rama University",
  "Sharda University",
  "Galgotias College of Engineering",
  "KIET Group of Institutions Ghaziabad",

  // ── West Bengal ──
  "Jadavpur University",
  "Calcutta University",
  "Bengal Engineering and Science University (IIEST Shibpur)",
  "Heritage Institute of Technology",
  "Institute of Engineering and Management (IEM Kolkata)",
  "St. Xavier's College Kolkata",
  "Presidency University Kolkata",
  "Techno India University",
  "Sister Nivedita University",
  "Brainware University",
  "Netaji Subhash Engineering College",
  "RCC Institute of Information Technology",

  // ── Kerala ──
  "College of Engineering Trivandrum (CET)",
  "NSS College of Engineering",
  "Government Engineering College Thrissur",
  "TKM College of Engineering",
  "Rajiv Gandhi Institute of Technology Kottayam",
  "Model Engineering College",
  "MES College of Engineering",
  "Kerala University",
  "Cochin University of Science and Technology (CUSAT)",
  "Calicut University",
  "Kannur University",
  "Amrita School of Engineering Coimbatore",
  "APJ Abdul Kalam Technological University",

  // ── Andhra Pradesh ──
  "Jawaharlal Nehru Technological University Anantapur (JNTUA)",
  "Andhra University",
  "SRM University AP",
  "VIT AP University",
  "Vignan's Foundation for Science Technology",
  "K L University",
  "Koneru Lakshmaiah Education Foundation",
  "GITAM University",
  "Acharya Nagarjuna University",
  "Sri Venkateswara University",

  // ── Odisha ──
  "NIT Rourkela",
  "KIIT University",
  "SOA University",
  "Utkal University",
  "Berhampur University",
  "Parala Maharaja Engineering College",
  "College of Engineering Bhubaneswar",
  "Silicon Institute of Technology",
  "ITER Bhubaneswar",
  "Trident Academy of Technology",

  // ── Jharkhand ──
  "IIT (ISM) Dhanbad",
  "NIT Jamshedpur",
  "BIT Mesra",
  "Birla Institute of Technology Mesra",
  "XLRI Jamshedpur",
  "Ranchi University",
  "Usha Martin University",
  "Central University of Jharkhand",

  // ── Bihar ──
  "NIT Patna",
  "IIM Bodh Gaya",
  "Patna University",
  "Bihar Agricultural University",
  "Magadh University",
  "Chanakya National Law University",
  "Central University of South Bihar",

  // ── Punjab / Haryana / Himachal Pradesh ──
  "Punjab Engineering College (PEC Chandigarh)",
  "Thapar Institute of Engineering and Technology",
  "Lovely Professional University (LPU)",
  "Chitkara University Punjab",
  "Punjab University Chandigarh",
  "Panjab University",
  "NIT Jalandhar",
  "Guru Nanak Dev University",
  "Chandigarh University",
  "Amity University Punjab",
  "NIT Kurukshetra",
  "NIT Hamirpur",
  "Maharishi Dayanand University Rohtak",
  "Kurukshetra University",
  "Guru Jambheshwar University",
  "DCR University of Science and Technology",
  "Himachal Pradesh University",
  "Jaypee University of Information Technology Solan",

  // ── Assam / Northeast ──
  "IIT Guwahati",
  "NIT Silchar",
  "Tezpur University",
  "Dibrugarh University",
  "Gauhati University",
  "NIT Arunachal Pradesh",
  "NIT Meghalaya",
  "NIT Manipur",
  "NIT Mizoram",
  "NIT Nagaland",
  "Assam University Silchar",

  // ── Goa ──
  "NIT Goa",
  "BITS Pilani Goa Campus",
  "Goa University",
  "Goa College of Engineering",
  "Don Bosco College of Engineering Goa",

  // ── Uttarakhand ──
  "IIT Roorkee",
  "Graphic Era University",
  "Uttarakhand Technical University",
  "Dev Sanskriti Vishwavidyalaya",
  "DIT University",
  "Quantum University",
  "Kumaun University",

  // ── Chhattisgarh ──
  "IIM Raipur",
  "NIT Raipur",
  "Pt. Ravishankar Shukla University",
  "Hidayatullah National Law University",
  "Kalyan Singh Super Speciality Cancer Institute",
  "Chhattisgarh Swami Vivekanand Technical University",

  // ── Jammu & Kashmir ──
  "NIT Srinagar",
  "IIT Jammu",
  "IIM Jammu",
  "University of Jammu",
  "University of Kashmir",
  "Central University of Kashmir",
  "Cluster University Srinagar",

  // ── Private/Deemed Universities ──
  "Amrita Vishwa Vidyapeetham",
  "SRM University Chennai",
  "VIT University Vellore",
  "Symbiosis International University",
  "Manipal Academy of Higher Education",
  "Shiv Nadar University",
  "Amity University",
  "Lovely Professional University",
  "Chandigarh University",
  "Thapar Institute",
  "Kalinga Institute of Industrial Technology (KIIT)",
  "Siksha O Anusandhan (SOA)",
  "SASTRA University",
  "Karunya Institute of Technology",
  "Vellore Institute of Technology",
  "Deemed University of Technology",
  "Sathyabama Institute of Science and Technology",
  "Hindustan Institute of Technology and Science",
  "Sri Ramachandra Institute of Higher Education",
  "Chettinad Academy of Research and Education",

  // ── Law Schools ──
  "NLSIU Bangalore",
  "NALSAR Hyderabad",
  "NLU Delhi",
  "WBNUJS Kolkata",
  "NLU Jodhpur",
  "GNLU Gandhinagar",
  "RMLNLU Lucknow",
  "CNLU Patna",
  "RGNUL Patiala",
  "HNLU Raipur",
  "NUALS Kochi",
  "NUSRL Ranchi",
  "NLUJAA Guwahati",
  "DSNLU Visakhapatnam",
  "TNNLS Tiruchirappalli",
  "Symbiosis Law School Pune",
  "Amity Law School",
  "Christ University School of Law",

  // ── Medical Colleges ──
  "Grant Medical College Mumbai",
  "Maulana Azad Medical College Delhi",
  "Seth GS Medical College Mumbai",
  "JIPMER Puducherry",
  "Christian Medical College Vellore",
  "Kasturba Medical College Manipal",
  "St. John's Medical College Bangalore",
  "KMC Mangalore",
  "Stanley Medical College Chennai",
  "Madras Medical College",
  "Osmania Medical College Hyderabad",
  "King George's Medical University Lucknow",
  "Bangalore Medical College",
  "Sri Ramachandra Medical College",
  "Amrita Institute of Medical Sciences",
  "PSG Institute of Medical Sciences",

  // ── Design / Fine Arts ──
  "National Institute of Design (NID Ahmedabad)",
  "NID Andhra Pradesh", "NID Assam", "NID Jorhat",
  "NID Kurukshetra", "NID Madhya Pradesh",
  "NID Sikkim", "NID Amaravati",
  "Industrial Design Centre IIT Bombay",
  "Pearl Academy",
  "NIFT Delhi", "NIFT Mumbai", "NIFT Chennai", "NIFT Bangalore",
  "NIFT Hyderabad", "NIFT Kolkata", "NIFT Gandhinagar", "NIFT Bhopal",
  "NIFT Patna", "NIFT Raebareli", "NIFT Shillong", "NIFT Kannur",
  "Srishti Manipal Institute",

  // ── Hospitality / Hotel Management ──
  "Institute of Hotel Management Mumbai",
  "Institute of Hotel Management Delhi",
  "Institute of Hotel Management Chennai",
  "Institute of Hotel Management Bangalore",
  "Institute of Hotel Management Kolkata",
  "Institute of Hotel Management Hyderabad",
  "Institute of Hotel Management Ahmedabad",
  "Welcomgroup Graduate School of Hotel Administration",

  // ── Agriculture ──
  "Indian Agricultural Research Institute (IARI)",
  "ICAR-National Dairy Research Institute",
  "Tamil Nadu Agricultural University",
  "Punjab Agricultural University",
  "G.B. Pant University of Agriculture and Technology",
  "ANGRAU",
  "Dr. PDKV Akola",
  "MPKV Rahuri",
  "BAU Ranchi",
  "AAU Jorhat",

  "Other",
];

export default INDIAN_COLLEGES;
